import { useCallback } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  ONCHAIN_SETTING_FETCH_BEGIN,
  ONCHAIN_SETTING_FETCH_SUCCESS,
  ONCHAIN_SETTING_FETCH_FAILURE,
  ONCHAIN_SETTING_UPDATE_BEGIN,
  ONCHAIN_SETTING_UPDATE_SUCCESS,
  ONCHAIN_SETTING_UPDATE_FAILURE,
} from "./constants";
import axios from "axios";
import { apiUrl } from "features/configure";
import { enqueueSnackbar } from "features/common/redux/actions";
import _ from "lodash";

export function fetchOnchainDataSetting({ entityName, ecosystem }) {
  return async (dispatch) => {
    dispatch({ type: ONCHAIN_SETTING_FETCH_BEGIN });

    try {
      const result = await axios.get(
        `${apiUrl}/api/manage/onchainData/${entityName}?ecosystem=${ecosystem}`
      );

      dispatch({
        type: ONCHAIN_SETTING_FETCH_SUCCESS,
        data: result.data,
      });
    } catch (err) {
      dispatch({ type: ONCHAIN_SETTING_FETCH_FAILURE });
      dispatch(
        enqueueSnackbar({
          message: _.get(
            err,
            "response.data.error",
            _.get(err, "response.data.message", "error")
          ),
          options: { variant: "error" },
        })
      );
    }
  };
}

export function updateOnchainDataSetting({ entityName, body }) {
  return async (dispatch) => {
    dispatch({ type: ONCHAIN_SETTING_UPDATE_BEGIN });

    try {
      const result = await axios.post(
        `${apiUrl}/api/manage/onchainData/${entityName}`,
        body
      );

      dispatch({
        type: ONCHAIN_SETTING_UPDATE_SUCCESS,
      });
    } catch (err) {
      dispatch({ type: ONCHAIN_SETTING_UPDATE_FAILURE });

      dispatch(
        enqueueSnackbar({
          message: _.get(
            err,
            "response.data.error",
            _.get(err, "response.data.message", "error")
          ),
          options: { variant: "error" },
        })
      );
    }
  };
}

export function useFetchOnchainDataSetting() {
  const dispatch = useDispatch();

  const {
    onchainDataSetting,
    fetchOnchainDataSettingPending,
    fetchOnchainDataSettingDone,
    updateOnchainDataSettingPending,
    updateOnchainDataSettingDone,
  } = useSelector(
    (state) => ({
      onchainDataSetting: state.metadesk.onchainDataSetting,
      fetchOnchainDataSettingPending:
        state.metadesk.fetchOnchainDataSettingPending,
      fetchOnchainDataSettingDone: state.metadesk.fetchOnchainDataSettingDone,
      updateOnchainDataSettingPending:
        state.metadesk.updateOnchainDataSettingPending,
      updateOnchainDataSettingDone: state.metadesk.updateOnchainDataSettingDone,
    }),
    shallowEqual
  );

  const boundFetch = useCallback(
    (params) => dispatch(fetchOnchainDataSetting(params)),
    [dispatch]
  );
  const boundUpdate = useCallback(
    (params) => dispatch(updateOnchainDataSetting(params)),
    [dispatch]
  );

  return {
    onchainDataSetting,
    fetchOnchainDataSetting: boundFetch,
    updateOnchainDataSetting: boundUpdate,
    fetchOnchainDataSettingPending,
    fetchOnchainDataSettingDone,
    updateOnchainDataSettingPending,
    updateOnchainDataSettingDone,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ONCHAIN_SETTING_FETCH_BEGIN:
      return {
        ...state,
        fetchOnchainDataSettingPending: true,
        fetchOnchainDataSettingDone: false,
      };
    case ONCHAIN_SETTING_FETCH_SUCCESS:
      return {
        ...state,
        onchainDataSetting: action.data,
        fetchOnchainDataSettingPending: false,
        fetchOnchainDataSettingDone: true,
      };
    case ONCHAIN_SETTING_FETCH_FAILURE:
      return {
        ...state,
        fetchOnchainDataSettingPending: false,
        fetchOnchainDataSettingDone: false,
      };

    case ONCHAIN_SETTING_UPDATE_BEGIN:
      return {
        ...state,
        updateOnchainDataSettingPending: true,
        updateOnchainDataSettingDone: false,
      };
    case ONCHAIN_SETTING_UPDATE_SUCCESS:
      return {
        ...state,
        updateOnchainDataSettingPending: false,
        updateOnchainDataSettingDone: true,
      };
    case ONCHAIN_SETTING_UPDATE_FAILURE:
      return {
        ...state,
        updateOnchainDataSettingPending: false,
        updateOnchainDataSettingDone: false,
      };

    default:
      return state;
  }
}
